
import { Component, inject } from '@angular/core';
import { ModalController } from '@ionic/angular';

export type EventTypeChoice =
  | 'single'
  | 'bulk'
  | 'block'
  | 'special'
  | 'dayuse';

interface ChoiceOption {
  id: EventTypeChoice;
  icon: string;
  title: string;
  description: string;
  badge?: string;
}

import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonTitle, IonToolbar } from '@ionic/angular/standalone';

@Component({
  selector: 'lessor-event-type-picker-modal',
  templateUrl: './event-type-picker-modal.component.html',
  styleUrls: ['./event-type-picker-modal.component.scss'],
  imports: [
    IonButton,
    IonButtons,
    IonContent,
    IonHeader,
    IonIcon,
    IonTitle,
    IonToolbar
  ],
})
export class EventTypePickerModalComponent {
  private readonly modalCtrl = inject(ModalController);

  readonly options: ChoiceOption[] = [
    {
      id: 'single',
      icon: 'calendar-outline',
      title: 'Reserva única',
      description:
        'Para um cliente em um horário específico. Toque num slot livre da grade ou continue para escolher.',
    },
    {
      id: 'bulk',
      icon: 'repeat-outline',
      title: 'Reservas em lote',
      description:
        'Crie várias reservas iguais (ex: turma todas as terças, 19h–20h, próximas 4 semanas).',
    },
    {
      id: 'block',
      icon: 'remove-circle-outline',
      title: 'Bloquear horários',
      description:
        'Indisponibilizar período (almoço, manutenção, férias). Pode marcar dias da semana.',
    },
    {
      id: 'special',
      icon: 'star-outline',
      title: 'Horário especial',
      description:
        'Disponibilize horários FORA do funcionamento normal da quadra. Ex: a quadra opera das 8h às 18h, mas você quer abrir das 19h às 23h em um dia específico.',
    },
    {
      id: 'dayuse',
      icon: 'sunny-outline',
      title: 'Day Use',
      description:
        'Venda o dia inteiro como acesso ao espaço, em vez de hora de quadra. Escolha os dias, a lotação e o preço — quem comprar entra com QR Code.',
    },
  ];

  select(choice: EventTypeChoice) {
    this.modalCtrl.dismiss({ choice });
  }

  dismiss() {
    this.modalCtrl.dismiss(null);
  }
}
